<template>
  <div style="padding:0 300px;">
    <Form ref="paymentForm" :model="data"
          :rules="validates">
      <Row>
        <Row :gutter="30">
          <Col span="24">
          <FormItem label="Chinese citizen?"
                    prop="chineseCitizen">
            <RadioGroup v-model="data.chineseCitizen">
              <Radio :label=1>Yes</Radio>
              <Radio :label=0>NO</Radio>
            </RadioGroup>
          </FormItem>
          </Col>
        </Row>
        <p class="dis-30">We can transfer to your or your family member's Paypal or 云账户.</p>
        <Row :gutter="30">
          <Col span="24">
          <FormItem label="请您选择收款方式"
                    prop="payWay">
            <RadioGroup v-model="payWay">
              <Radio :label=INLAND>云账户</Radio>
              <Radio :label=PAYPAL>PayPal</Radio>
            </RadioGroup>
          </FormItem>
          </Col>
        </Row>
        <Row :gutter="30">
          <Col span="8">
          <FormItem label="收款人姓名"
                    v-if="payWay==='INLAND'"
                    prop="payeeName">
            <Input v-model="data.payeeName"
            style="width:200px"
                   placeholder="账号所有者姓名"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="银行卡号"
                    v-if="payWay==='INLAND'"
                    prop="cardNumber">
            <Input v-model="data.cardNumber" style="width:200px"
                   placeholder="云账户账号"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="手机号"
                    v-if="payWay==='INLAND'"
                    prop="payeePhone">
            <Input v-model="data.payeePhone" style="width:200px"
                   placeholder="与银行账户绑定的手机号，用于接收验证码"></Input>
          </FormItem>
          </Col>
          <Col span="24">
          <FormItem label="收款人证件号（如选择护照或港澳台来往内地通行证，需要上传护照/港澳台来往内号码页地正面截图）"
                    prop="nationality"
                    v-if="payWay==='INLAND'">
            <RadioGroup v-model="nationality">
              <Radio :label=NATIONAL>大陆籍</Radio>
              <Radio :label=UNNATIONAL>非大陆籍</Radio>
            </RadioGroup>
          </FormItem>
          </Col>
          <Col span="12"
               v-if="payWay==='INLAND'">
          <FormItem label="身份证号"
                    v-if="nationality==='NATIONAL'"
                    prop="payeeIdCard">
            <Input v-model="data.payeeIdCard"
                   placeholder="身份证号"></Input>
          </FormItem>
          </Col>
          <Col span="8"
               v-if="payWay==='INLAND'">
          <FormItem v-if="nationality==='UNNATIONAL'"
                    prop="payeeIdType">
            <RadioGroup v-model="data.payeeIdType">
              <Radio :label=PASSPORT>护照号</Radio>
              <Radio :label=PASSAGE>港澳台来往内地通行证号</Radio>
            </RadioGroup>
          </FormItem>
          </Col>
          <Col span="8"
               v-if="payWay==='INLAND'">
          <FormItem v-if="nationality==='UNNATIONAL'"
                    prop="payeeIdCard">
            <Input v-model="data.payeeIdCard"></Input>
          </FormItem>
          </Col>
          <Col span="12"
               v-if="payWay==='INLAND'">
          <FormItem v-if="nationality==='UNNATIONAL'">
            <!-- <a class="blue"
               @click="handleUpload(data.id, emItem.id, emItem.jointId)"
               v-if="userRole === 'EM' && emItem.status === 'NOTEDIT' ">Upload</a> -->
            <file-upload v-model="path"
                         path="passport/"
                         :secret="true"
                         :random-filename-length=1
                         :type="imgType"
                         @input="onUploadSuccess">
                         <!-- <Button type="ghost" icon="ios-cloud-upload-outline">上传截图 upload screenshots</Button> -->
                         </file-upload>
            <div v-if="downloadPath"><div style="color: #2D8CF0;cursor:pointer;" @click="downloadHandler">Download</div></div>
          </FormItem>
          </Col>
          <Col span="8"
               v-if="payWay==='PAYPAL'">
          <FormItem label="Account Currency"
                    prop="currency">
            <RadioGroup v-model="data.currency">
              <Radio :label=USD>USD</Radio>
              <Radio :label=GBP>GBP</Radio>
              <Radio :label=HKD>HKD</Radio>
            </RadioGroup>
          </FormItem>
          </Col>
          <Col span="8"
               v-if="payWay==='PAYPAL'">
          <FormItem label="Paypal"
                    prop="payPalEmail">
            <Input v-model.trim="data.payPalEmail"
                   placeholder="Paypal"></Input>
          </FormItem>
          </Col>
          <Col span="8"
               v-if="payWay==='PAYPAL'">
          <FormItem label="Registe Country">
              <Select v-model="data.registeCountry" :filterable="true" :clearable="true">
                  <Option v-for="item in univCountryList" :value="item.name" :key="item.name">{{ item.name }}</Option>
                </Select>
          </FormItem> 
          </Col>
        </Row>
      </Row>
      <div>
        <Button type="primary"
                style="margin-right: 24px"
                @click="save('paymentForm')">Submit</Button>
        <Button @click="cancel">Close</Button>
      </div>
    </Form>
  </div>
</template>

<script>
import { modifyPayment } from '@/api/talents'
import FileUpload from '@/components/upload/upload'
import { isEmail } from '@/libs/validator'
import { getAreaCountryEn} from '@/libs/area/area'
import { ossSecretLink} from '@/api/oss'
import store from '@/store'
export default {
  name:'paymentEdit',
  components: { 
    FileUpload
   },
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    const checkPayeeIdCard = (rule, value, callback) => {
      if (this.payWay === 'INLAND' && value === '') {
        callback(new Error('必填'))
      } else {
        callback()
      }
    }
    const checkPayeeName = (rule, value, callback) => {
      if (this.payWay === 'INLAND' && value === '') {
        callback(new Error('必填'))
      } else {
        callback()
      }
    }
    const checkCardNumber = (rule, value, callback) => {
      if (this.payWay === 'INLAND' && value === '') {
        callback(new Error('必填'))
      } else {
        callback()
      }
    }
    const checkPayeePhone = (rule, value, callback) => {
      if (this.payWay === 'INLAND' && value === '') {
        callback(new Error('必填'))
      } else {
        callback()
      }
    }

    const checkPayPalEmail = (rule, value, callback) => {
      if (this.payWay === 'PAYPAL' && value === '') {
        callback(new Error('必填'))
      } else if (!isEmail(value)) {
        callback(new Error('请输入正确格式的邮箱'))
      } else {
        callback()
      }
    }

    const checkPayPalCurrency = (rule, value, callback) => {
      if (this.payWay === 'PAYPAL' && !value) {
        callback(new Error('必填'))
      } else {
        callback()
      }
    }

    return {
      imgType:"OSS",
      nationality:null,
      payWay:null,
      data:{},
      univCountryList: [],
      path: undefined,
      downloadPath: '',
      form: {},
      validates: {
        chineseCitizen: [
          { required: true, message: '必填' }
        ],
        payWay: [
          { required: true, message: '必填' }
        ],
        payeeIdCard: [
          { validator: checkPayeeIdCard, trigger: 'blur' }
        ],
        payeeName: [
          { validator: checkPayeeName, trigger: 'blur' }
        ],
        cardNumber: [
          { validator: checkCardNumber, trigger: 'blur' }
        ],
        payeePhone: [
          { validator: checkPayeePhone, trigger: 'blur' }
        ],
        payPalEmail: [
          { validator: checkPayPalEmail, trigger: 'blur' }
        ],
        currency: [
          { validator: checkPayPalCurrency, trigger: 'blur' }
        ]
      },
      PAYPAL: 'PAYPAL',
      INLAND: 'INLAND',
      NATIONAL: 'NATIONAL',
      UNNATIONAL: 'UNNATIONAL',
      PASSPORT: 'PASSPORT',
      PASSAGE: 'PASSAGE',
      USD: 'USD',
      GBP: 'GBP',
      HKD: 'HKD',
      talentsId:null
    }
  },
  mounted () {
    this.univCountryList = getAreaCountryEn()
    this.data = this.info
    this.downloadPath = this.data.screenshot
    this.payWay = this.data.payWay
    this.nationality = this.data.nationality
    store
      .dispatch('getUserRole')
      .then(res => {
        this.talentsId = res.talentsId
      })
  },

  methods: {
    downloadHandler(){
      ossSecretLink({
        dir: this.downloadPath
      }).then(res => {
        console.log(res)
        window.open(res.data.url)
      })
    },
    onUploadSuccess (path) {
      // this.data.screenshot = path.name
      this.downloadPath = path
    },
    save (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let param = {
            contractPaypalInfo: {},
            contractInlandInfo: {}
          }
          param.talentsId = this.talentsId
          param.chineseCitizen = this.data.chineseCitizen
          param.payWay = this.payWay
          if (this.payWay === 'PAYPAL') {
            param.contractPaypalInfo.currency = this.data.currency
            param.contractPaypalInfo.payPalEmail = this.data.payPalEmail
            param.contractPaypalInfo.registeCountry = this.data.registeCountry
          } else {
            param.contractInlandInfo.payeeName = this.data.payeeName
            param.contractInlandInfo.cardNumber = this.data.cardNumber
            param.contractInlandInfo.payeePhone = this.data.payeePhone
            param.contractInlandInfo.nationality = this.nationality
            if (this.nationality === 'NATIONAL') {
              // 如果是大陆籍 只有身份证号
              param.contractInlandInfo.payeeIdCard = this.data.payeeIdCard
            } else {
              // 非大陆籍
              param.contractInlandInfo.payeeIdCard = this.data.payeeIdCard
              param.contractInlandInfo.screenshot = this.downloadPath
              param.contractInlandInfo.payeeIdType = this.data.payeeIdType
              if(!param.contractInlandInfo.payeeIdType){
                this.$Message.info('证件类型不能为空');
                return false
              }
            }
          }
          param.talentsId = this.talentsId
          modifyPayment(param).then(res => {
            if (res.code === 0) {
              this.$emit('on-submit')
            }
          }).catch(err => {
              console.log(err)
              this.$Message.warning(err.message);
          })

        }
      })
    },
    cancel () {
      this.$emit('on-cancel')
    }
  }
}
</script>

<style scoped>
.part {
  margin-bottom: 24px;
}
</style>
